export default __webpack_public_path__ + "static/media/empty_document.9c011c38.png";